import React from 'react';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function ClientRightInstallation(props){

  const {RightLinkSelection, updateRightLinkSelection, updateInstallationLinkSelection, updateLinkSelection } = useContext(MyContext);
  const active = "BIcon active";
  const notActive = "BIcon";

  const update = () =>{
    
    updateInstallationLinkSelection("Bank")
    updateLinkSelection("")
  }
  

    return (
       
        <>
        
      
<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>


<div className="card-body">
<div style={{display: "flex"}}>


<span style={{width:"45%", display:"flex"}}>

<span style={{marginRight:"40px"}}>
<div style={{display: "flex"}}>
    
    <p className="card-title"><strong>{props.name}</strong></p></div>
  
    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>
    
   
    </div>



</span>
<span style={{marginRight:"40px"}}>

    <p><strong>Unique ID: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">fingerprint</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.id}</span>
  
  </div>

</span>

</span>

<span style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("graphs")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >query_stats</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>Bank Graph</span></span>

</span>

<span style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("AllPacks")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >dns</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>All Pack</span></span>

</span>

<span  style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("BankInformation")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >info</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Bank Info </span></span>

</span>

<span  style={{width:"12%"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("Battery")} style={{height:"100%", margin: "0px", paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size" style={{paddingTop:"0px"}}>battery_plus</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Add Battery </span></span>

</span>


</div>
</div>
</div>

             

        </>
    )
}

export default ClientRightInstallation;